import { createClient } from '@supabase/supabase-js';

// The anon key in a browser bundle is expected and safe — it grants nothing on its
// own, and every admin read is authorized server-side by the /admin gate. This
// client exists only to run the Google OAuth flow and hold the resulting session.
//
// Both vars are non-optional (src/vite-env.d.ts) and are supplied under vitest by
// apps/admin/vitest.config.ts's test.env, not by a fallback here — see that
// file's comment for why a runtime fallback would be unsafe.
export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
  { auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true } },
);

export async function signInWithGoogle() {
  const { error } = await supabase.auth.signInWithOAuth({
    provider: 'google',
    options: {
      redirectTo: `${window.location.origin}/users`,
      // Domain-locking the OAuth client is the first fence; the API's gate is the
      // one that counts. This just keeps the account chooser tidy.
      queryParams: { hd: 'ascera.life', prompt: 'select_account' },
    },
  });
  if (error) throw error;
}

// Global on purpose: ends every session this account holds, including the ops MCP
// login and any mobile app session on the same Google account.
export async function signOutEverywhere() {
  await supabase.auth.signOut({ scope: 'global' });
}
